import { render, staticRenderFns } from "./OAuthError.vue?vue&type=template&id=efc4c4c8&scoped=true"
import script from "./OAuthError.vue?vue&type=script&lang=js"
export * from "./OAuthError.vue?vue&type=script&lang=js"
import style0 from "./OAuthError.vue?vue&type=style&index=0&id=efc4c4c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc4c4c8",
  null
  
)

export default component.exports